import { detectAnyAdblocker } from 'just-detect-adblock'

class AdBlockDetector {
    static setRuntimeParams(adblockerIsDetected) {
        window.picoAdBlocking = adblockerIsDetected
    }

    static isEnabled() {
        return window.picoAdBlocking !== undefined
    }

    static async init() {
        const adblockerIsDetected = await detectAnyAdblocker()

        AdBlockDetector.setRuntimeParams(adblockerIsDetected)

        return adblockerIsDetected
    }
}

export default AdBlockDetector
